module.exports = __webpack_public_path__ + "img/VL_07_01.9092e11b.png";